import React, { type FC, type PropsWithChildren, memo } from 'react';
import cn from 'clsx';
import { Text as TextTPA } from '@wix/wix-ui-tpa/cssVars';
import { DH } from '../../../utils/DataHook';
import { type Theme } from '../../../types/Theme';
import s from './redesign.scss';
import { classes } from './styles.st.css';

export const RedesignedForm: FC<PropsWithChildren<{ isHidden: boolean; theme: Theme }>> = memo((props) => (
  <div
    data-hook={DH.Form}
    data-is-hidden={props.isHidden}
    className={cn(s.redesignedLayout, classes.form, {
      [classes.minimal]: props.theme === 'minimal',
    })}
  >
    {props.children}
  </div>
));
RedesignedForm.displayName = 'RedesignedForm';

export const RedesignedFieldsGroup: FC<PropsWithChildren<{}>> = memo((props) => (
  <div className={s.redesignedFieldGroup}>{props.children}</div>
));
RedesignedFieldsGroup.displayName = 'RedesignedFieldsGroup';

export const Text: FC<PropsWithChildren<{}>> = memo((props) => (
  <TextTPA className={classes.text}>{props.children}</TextTPA>
));
Text.displayName = 'Text';
